import { useTranslation } from 'react-i18next';
import { BaseActionsGrid, SOSButtonConfig } from "@/core/components/actions";
import { StressLogCard } from "./StressLogCard";
import { AnxietyLogCard } from "./AnxietyLogCard";
import { MoodLogCard } from "@/components/actions/MoodLogCard";

interface ReliefActionsGridProps {
  onDataUpdate?: () => void;
}

export function ReliefActionsGrid({ onDataUpdate }: ReliefActionsGridProps) {
  const { t } = useTranslation();

  const sosConfig: SOSButtonConfig = {
    gradientClasses: "bg-gradient-to-br from-sky-500 to-cyan-600",
    hoverGradientClasses: "hover:from-sky-600 hover:to-cyan-700",
    translations: {
      buttonLabel: "mindco-relief:actions.sosButton",
      buttonLabelFallback: t('mindco-relief:actions.sosButton', 'SOS Support'),
      buttonHelp: "mindco-relief:actions.sosHelp",
      buttonHelpFallback: t('mindco-relief:actions.sosHelp', 'Get instant support'),
      toastTitle: "mindco-relief:actions.supportAvailable",
      toastTitleFallback: t('mindco-relief:actions.supportAvailable', 'Support Available'),
      toastDescription: "mindco-relief:actions.supportOpening",
      toastDescriptionFallback: t('mindco-relief:actions.supportOpening', 'Opening support chat to help you.'),
    },
    analyticsEvent: 'SOS Support Help',
  };
  return (
    <BaseActionsGrid
      titleKey="mindco-relief:actions.title"
      titleFallback="Quick Actions"
      sosConfig={sosConfig}
    >
      <StressLogCard onDataUpdate={onDataUpdate} />
      <AnxietyLogCard onDataUpdate={onDataUpdate} />
      <MoodLogCard onDataUpdate={onDataUpdate} />
    </BaseActionsGrid>
  );
}
